import React,{useEffect, useState} from "react";
import "./quote.css";

const quots = [
    ["Un défaut qui empêche les hommes d'agir, c'est de ne pas sentir de quoi ils sont capables.","Jacques-Bénigne Bossuet"],
    ["if you have everything under control you're not moving fast enough","Mario Andretti"],
    ["Il n'est rien qui ne rend plus humble que de se confier en Dieu. ", "Jean Chrysostome"],
    ["Beaucoup de médecins croient connaître l'homme, et ils ne connaissent que l'animal.", "Henri Perreyve "],
    ["Tous les moments sont chers à qui connaît le prix du temps.", "Gabriel Girard "], 
    ["La noblesse est un laurier dont le temps couronne les hommes.","Francis Bacon"],
    [" L'ignorance facilite à la bassesse les plus misérables calomnies.","Germaine de Staël "],
    ["On n'agit pas toujours aussi bien que l'on pense","Pierre-Claude Nivelle de La Chaussée"],
    ["La porte du coffre bâille comme l'auditoire d'un conférencier.","Frédéric Dard "],
    ["L'ambition, en portant toutes nos idées sur l'avenir, nous empêche de jouir du présent.","David Augustin de Brueys "],
    [" Imitez, copiez les bonnes mœurs, jusqu'à ce que l'habitude s'en empare.","Philip Dormer Stanhope"],
    ["Un seul être vous manque, et est dépeuplé.","Alphonse de Lamartine"],
    ["N'entretiens pas l'espoir de ce qui ne peut être espéré.","Pythagore"],
    ["Aimer, ce n'est pas se regarder l'un l'autre, c'est regarder ensemble dans la même direction.","Antoine deSait-Exupéry"],
    ["Celui qui vit avec son passé n'a pas d'avenir.","Stone"],
    ["L’homme sage pardonne sans bruit.","Reis Mirdita" ],
    ["Les plus grandes joies sont celles qui viennent à l'improviste.","Naoual Younsi"],
    ["Si vous pensez que l'aventure est dangereuse, essayez la routine elle est mortelle.","Paul Coelho"],
    ["L'humilité précède la gloire.","Proverbes 15:33 "]
    
  ];

export default () => {
    
    const [quot, setQuot] = useState(quots[Math.floor(Math.random()*quots.length)])
    useEffect(()=>{
        const rando = Math.floor(Math.random()*quots.length);
        let slider = setInterval(() => {
            setQuot(quots[rando]);
        }, 5000);
        return () => {
            clearInterval(slider)
        }
    },[quot])
    return (
        <div id="quote-box">
            <div id="wrapper">
                <i className="fa fa-quote-left"></i>
                <div id="text">
                    {quot[0]}
                </div>
                <div id="author">
                    {"-"+quot[1]}
                </div>
            </div>
        </div>
    )
}